import {useState} from "react";
import {css} from "@emotion/react";

import { Link } from "react-router-dom";
import Text from "@/base/Text";
import Header from "@/base/Header";
import Form from "@/base/Form";
import FormInput from "@/base/FormInput";
import FieldError from "@/base/FieldError";
import { rem } from "@util/convertUnits";

const ContactUsForm = () => {

    const roles = [
        {
            label: "Homeowner",
            value: "homeowner",
        },
        {
            label: "Builder/Contractor",
            value: "builder_contractor",
        },
        {
            label: "Architect/Designer",
            value: "architect_designer",
        },
        {
            label: "Dealer",
            value: "dealer",
        },
        {
            label: "Other",
            value: "other",
        },
    ];

    const [, setFormData] = useState({})
    const [formIsComplete, setFormIsComplete] = useState(false);

    const stepText = css(`
        text-align:center;
        margin-top:3em;
    `);

    const containerCss = css(`
        width: 100%;
        max-width: ${rem(800)};
        margin-left: auto;
        margin-right: auto;
    `);

    const formCss = css(`
        width: 100%;
        max-width: ${rem(520)};
        margin-left: auto;
        margin-right: auto;
    `);

    const smWrap = css(`
        max-width: 39.8rem;
        margin-left: auto;
        margin-right: auto;
    `);


    if (formIsComplete) {
        return (
            <div>
                <Header tag="h3">Request received. Thank you.</Header>
                <Text>We will be in touch within two business days to assist you.</Text>
                <Text>Also note: we&rsquo;ve sent you an email to confirm the information you&rsquo;ve provide.</Text>
                <br/>
                <Link to={'/'}>Continue exploring LaCantina Doors</Link>
            </div>
        );
    }

    return (
        <>
            <div className="mb-3" css={containerCss}>
            <Text>
                Complete the steps below, and a LaCantina Doors representative will
                assist you.
            </Text>
            </div>
            <div css={formCss}>
                <Form name="lac_contact_us" onChange={setFormData} onSuccess={() => setFormIsComplete(true)}>

                    <fieldset css={smWrap}>
                        <Header tag="h4" tagStyle="h5">What is your role?</Header>
                        <FieldError name={`role`}/>
                        <div className="row">
                            {roles.map(role =>
                                <div className="size-full size-xs-1of2" key={role.label}>
                                    <FormInput
                                        type="radio"
                                        label={role.label}
                                        name="role"
                                        value={role.value}
                                    />
                                </div>
                            )}
                        </div>
                    </fieldset>

                    <Text css={stepText}>Step 2 of 4</Text>
                    <fieldset css={smWrap}>
                        <Header tag="h4" tagStyle="h5">
                            What is the subject of your comment or question?
                        </Header>
                        <Text>Select an option.</Text>
                        <FieldError name={`subject`}/>
                        <div className="row">
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="radio"
                                    label="Sales assistance"
                                    name="subject"
                                    value="sales"
                                />
                            </div>
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="radio"
                                    label="Product information"
                                    name="subject"
                                    value="product_info"
                                />
                            </div>
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="radio"
                                    label="Architectural/technical information"
                                    name="subject"
                                    value="technical_info"
                                />
                            </div>
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="radio"
                                    label="Shipping &amp; Delivery inquiries"
                                    name="subject"
                                    value="shipping_delivery"
                                />
                            </div>
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="radio"
                                    label="Accounting &amp; Billing inquiries"
                                    name="subject"
                                    value="account_billing"
                                />
                            </div>
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="radio"
                                    label="Marketing, advertising, and PR opportunities"
                                    name="subject"
                                    value="marketing"
                                />
                            </div>
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="radio"
                                    label="Careers"
                                    name="subject"
                                    value="careers"
                                />
                            </div>
                        </div>
                    </fieldset>

                    <Text css={stepText}>Step 3 of 4</Text>
                    <fieldset>
                        <Header tag="h4" tagStyle="h5">
                            Is there anything else you&apos;d like us to know about the project?
                        </Header>
                        <div>
                            <FormInput
                                type="textarea"
                                label="Message (Optional)"
                                name="message"
                                charLimit={1500}
                                builtinError={true}
                            />
                        </div>
                    </fieldset>

                    <Text css={stepText}>Step 4 of 4</Text>
                    <fieldset>
                        <Header tag="h4" tagStyle="h5">Let us know how to contact you.</Header>
                        <div>
                            <FormInput
                                type="text"
                                label="First Name"
                                required={true}
                                name="first_name"
                                builtinError={true}
                            />
                            <FormInput
                                type="text"
                                label="Last Name"
                                required={true}
                                name="last_name"
                                builtinError={true}
                            />
                            <FormInput
                                type="email"
                                label="Email"
                                required={true}
                                name="email"
                                builtinError={true}
                            />
                            <FormInput
                                type="phone"
                                label="Phone Number"
                                required={true}
                                name="phone"
                                builtinError={true}
                            />
                            <FormInput
                                type="text"
                                label="Zip code"
                                required={true}
                                name="zip"
                                builtinError={true}
                            />
                        </div>
                        <div css={smWrap}>
                            <FormInput
                                type="checkbox"
                                checked={true}
                                label="Yes, I'd like to receive news and product updates from LaCantina&trade; Doors."
                                name="product_updates"
                                builtinError={true}
                            />
                        </div>
                    </fieldset>
                    
                </Form>
            </div>
        </>
    );
};

export default ContactUsForm;
